var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"boton_flotante"}},[_c('v-btn',{staticClass:"boton",attrs:{"href":"#section_banner"}},[_c('a',{staticClass:"enlace_boton"},[_c('v-icon',[_vm._v("mdi-arrow-up")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }